import { auth } from "../plugins/firebase";
import { isBenignFirebaseSignOutError } from "./firebaseErrors";

/**
 * Returns true when Firebase still has an in-memory user but browser
 * persistence was wiped (e.g. DevTools "Clear site data").
 * Calling auth.signOut() in that state throws InvalidStateError on IndexedDB.
 */
export function isFirebasePersistenceMissing() {
  return Boolean(auth.currentUser) && !localStorage.getItem("user");
}

/**
 * Signs out from Firebase when persistence is healthy; otherwise skips the SDK
 * call and signals that a full page reload is needed to reset in-memory auth.
 */
export async function safeFirebaseSignOut() {
  if (!auth.currentUser) {
    return { requiresReload: false };
  }

  if (isFirebasePersistenceMissing()) {
    return { requiresReload: true };
  }

  try {
    await auth.signOut();
    return { requiresReload: false };
  } catch (error) {
    if (!isBenignFirebaseSignOutError(error)) {
      console.error("Error signing out:", error);
    }

    return { requiresReload: Boolean(auth.currentUser) };
  }
}
